import { render, staticRenderFns } from "./SettingSpareParts.vue?vue&type=template&id=624797ce&"
import script from "./SettingSpareParts.vue?vue&type=script&lang=ts&"
export * from "./SettingSpareParts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports